import { render, staticRenderFns } from "./Tab5UrineResults.vue?vue&type=template&id=0416e27a&scoped=true&"
import script from "./Tab5UrineResults.vue?vue&type=script&lang=js&"
export * from "./Tab5UrineResults.vue?vue&type=script&lang=js&"
import style0 from "./Tab5UrineResults.vue?vue&type=style&index=0&id=0416e27a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0416e27a",
  null
  
)

export default component.exports